import styled from 'styled-components';

export const Root = styled.div`
  display: flex;

  .icon {
    margin-right: 0.5rem;
  }
`;
